import { DetailsCard, DetailsDialog } from '.';

import { OrganizationContextProvider } from '../model';

const OrganizationContainer = () => {
  return (
    <OrganizationContextProvider>
      <DetailsCard />
      <DetailsDialog />
    </OrganizationContextProvider>
  );
};

export default OrganizationContainer;
